module.exports = __webpack_public_path__ + "static/logo-3c8ae2248234ebd44c18abf3954669cd.svg";